/** Maximum size for a single uploaded file (10 MB). */
export const MAX_UPLOAD_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_UPLOAD_FILE_SIZE_MB = 10;

export const formatUploadFileSize = (bytes) => {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

export const getUploadSizeLimitError = (file) => {
  const name = file?.name || "File";
  return `"${name}" exceeds the ${MAX_UPLOAD_FILE_SIZE_MB} MB upload limit (${formatUploadFileSize(file?.size)}).`;
};

export const isFileWithinUploadLimit = (file) => {
  if (!file || typeof file.size !== "number") return true;
  return file.size <= MAX_UPLOAD_FILE_SIZE_BYTES;
};

export const getFilesFromFormData = (formData) => {
  if (!(formData instanceof FormData)) return [];
  const files = [];
  formData.forEach((value) => {
    if (value instanceof File || value instanceof Blob) {
      files.push(value);
    }
  });
  return files;
};

export const validateUploadFiles = (files) => {
  const list = (Array.isArray(files) ? files : [files]).filter(Boolean);
  const oversized = list.filter((file) => !isFileWithinUploadLimit(file));
  if (!oversized.length) {
    return { ok: true };
  }
  return {
    ok: false,
    error: getUploadSizeLimitError(oversized[0]),
    oversizedFiles: oversized,
  };
};

export const validateUploadFormData = (formData) =>
  validateUploadFiles(getFilesFromFormData(formData));

export const createUploadSizeLimitError = (validation) => {
  const err = new Error(validation.error);
  err.code = "UPLOAD_SIZE_EXCEEDED";
  err.oversizedFiles = validation.oversizedFiles;
  return err;
};
